import { render, staticRenderFns } from "./AddKitchen.vue?vue&type=template&id=4e105716&"
import script from "./AddKitchen.vue?vue&type=script&lang=js&"
export * from "./AddKitchen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports